export default {
  namespaced: true,
  state: {
    endpoint: "/hive/prepress/layouts",
    key: "file",
    fetchKey: "files",
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  }
};
